import '../card.css'
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom'
import Axios from "axios";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CoverDisplay from '../../components/ImagesPage';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MutatingDots } from 'react-loader-spinner'

const GRADE_OPTIONS = ["All", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

function PsaWall() {
  const [cardList, setCardList] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState("All");
  const [hideSold, setHideSold] = useState(false);
  const [hideCracked, setHideCracked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  useEffect(() => {
    let isMounted = true;

    const fetchCards = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await Axios.get("https://api.alientrader.cards/data/dbsearch", {
          params: { card_grader: "PSA" },
        });

        if (isMounted) {
          const sortedCards = Array.isArray(response.data)
            ? [...response.data].sort((a, b) => Number(b.card_id) - Number(a.card_id))
            : [];

          setCardList(sortedCards);
        }
      } catch (fetchError) {
        console.error("Error fetching PSA cards:", fetchError);
        if (isMounted) {
          setError("Unable to load PSA cards right now.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCards();

    return () => {
      isMounted = false;
    };
  }, []);

  const filteredCards = useMemo(() => {
    let nextCards = cardList;

    if (selectedGrade !== "All") {
      nextCards = nextCards.filter((card) => String(card.card_grade_number) === selectedGrade);
    }

    if (hideSold) {
      nextCards = nextCards.filter((card) => card.card_owner !== "Sold");
    }

    if (hideCracked) {
      nextCards = nextCards.filter((card) => card.card_owner !== "Cracked");
    }

    return nextCards;
  }, [cardList, hideCracked, hideSold, selectedGrade]);

  return (
    <div className="imagesPage">
      <div className='actions'>
        <div className='subBack'><ArrowBackIcon onClick={goBack} /></div>
        <div className='cardWallGrader'><h1>PSA</h1></div>
        <div className='subEdit'></div>
      </div>
      <Container fluid>
        <Row className='justify-content-center'>
          <Col xl={10}>
            <div className='grade-filter-bar'>
              {GRADE_OPTIONS.map((gradeOption) => (
                <button
                  key={gradeOption}
                  type="button"
                  className={`grade-filter-button ${selectedGrade === gradeOption ? 'active' : ''}`}
                  onClick={() => setSelectedGrade(gradeOption)}
                >
                  {gradeOption}
                </button>
              ))}
              <button
                type="button"
                className={`grade-filter-button ${hideSold ? 'active' : ''}`}
                onClick={() => setHideSold((currentValue) => !currentValue)}
              >
                Hide Sold
              </button>
              <button
                type="button"
                className={`grade-filter-button ${hideCracked ? 'active' : ''}`}
                onClick={() => setHideCracked((currentValue) => !currentValue)}
              >
                Hide Cracked
              </button>
            </div>
          </Col>
        </Row>
        <Row className='justify-content-center'>
          <Col xs="auto">
            <div className='custom-info-header'>
              Showing {filteredCards.length.toLocaleString()} PSA cards
            </div>
          </Col>
        </Row>
        <Row><br /></Row>
        {loading ? (
          <div className="loader-container">
            <MutatingDots
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              secondaryColor="#4fa94d"
              radius="12.5"
              ariaLabel="mutating-dots-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        ) : error ? (
          <Row className='justify-content-center'>
            <Col xs="auto">
              <div className='custom-info-header'>{error}</div>
            </Col>
          </Row>
        ) : (
          <Row>
            {filteredCards.map((item, index) => (
              <Col className='imagesPageRow d-flex align-items-center justify-content-center' key={item.card_id}>
                <CoverDisplay key={index} image={item} />
              </Col>
            ))}
          </Row>
        )}
      </Container>
      <br />
    </div>
  );
}

export default PsaWall;
